import React, { useCallback, useEffect, useRef, useState } from 'react';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { compradores, minutosDesdeCompra } from '../data/compras';
import { oferta } from '../data/oferta';
interface Aviso {
  nombre: string;
  lugar: string;
  cuando: string;
}
function elegir<T>(lista: T[]): T {
  return lista[Math.floor(Math.random() * lista.length)];
}
function crearAviso(primero: boolean): Aviso {
  const persona = elegir(compradores);
  const ahora = primero || Math.random() < 0.4;
  return {
    nombre: persona.nombre,
    lugar: persona.lugar,
    cuando: ahora ? 'en este momento' : `hace ${elegir(minutosDesdeCompra)} min`
  };
}
const DURACION_VISIBLE = 6000;
const PAUSA_MINIMA = 40000;
const PAUSA_MAXIMA = 60000;
export function PurchaseToast() {
  const [aviso, setAviso] = useState<Aviso | null>(null);
  const [visible, setVisible] = useState(false);
  const [cerrado, setCerrado] = useState(false);
  const timers = useRef<number[]>([]);
  const limpiar = useCallback(() => {
    timers.current.forEach(id => window.clearTimeout(id));
    timers.current = [];
  }, []);
  useEffect(() => {
    if (cerrado) {
      limpiar();
      setVisible(false);
      return;
    }
    let esPrimero = true;
    const programar = (retraso: number) => {
      const id = window.setTimeout(() => {
        setAviso(crearAviso(esPrimero));
        esPrimero = false;
        setVisible(true);
        const ocultar = window.setTimeout(() => {
          setVisible(false);
          const siguiente = PAUSA_MINIMA + Math.random() * (PAUSA_MAXIMA - PAUSA_MINIMA);
          programar(siguiente);
        }, DURACION_VISIBLE);
        timers.current.push(ocultar);
      }, retraso);
      timers.current.push(id);
    };
    programar(9000);
    return limpiar;
  }, [cerrado, limpiar]);
  if (cerrado || !aviso) return null;
  return <div aria-live="polite" className={`pointer-events-none fixed inset-x-3 top-3 z-40 flex justify-center transition-[opacity,transform] duration-200 ease-out sm:inset-x-auto sm:bottom-5 sm:left-5 sm:top-auto sm:justify-start ${visible ? 'translate-y-0 opacity-100' : '-translate-y-2 opacity-0 sm:translate-y-2'}`} data-id="element-129" data-mp="rq6cmv48uxmz">
      <div className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-xl border border-cream-300 bg-white px-3 py-2.5 shadow-lift" data-id="element-130" data-mp="28ttb321boahf">
        <BadgeCheckIcon className="h-7 w-7 shrink-0 text-gold-600" strokeWidth={1.8} aria-hidden="true" data-id="element-131" data-mp="1h2n8mey4q0oz" />
        <div className="min-w-0 flex-1" data-id="element-132" data-mp="1c5n448gxh5zz">
          <p className="flex items-center gap-1.5 font-sans text-[10px] font-bold uppercase tracking-[0.14em] text-gold-600" data-id="element-133" data-mp="1q3lfr63v6obs">
            <span className="h-1.5 w-1.5 rounded-full bg-brick" aria-hidden="true" data-id="element-134" data-mp="1l4h4m9xdqgit" />
            Compra verificada
          </p>
          <p className="truncate font-sans text-sm font-semibold text-ink-900" data-id="element-135" data-mp="2wjxh1g1zgmbl">
            {aviso.nombre} · {aviso.lugar}
          </p>
          <p className="truncate font-sans text-xs text-ink-600" data-id="element-136" data-mp="34zv1bdhco521">
            Compró el Mega Pack · {oferta.precio} · {aviso.cuando}
          </p>
        </div>
        <button type="button" onClick={() => setCerrado(true)} aria-label="Cerrar aviso de compra" className="shrink-0 rounded-md p-1 text-ink-600 transition-colors duration-150 ease-out hover:bg-cream-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink-600" data-id="element-137" data-mp="2v2qfxfvbwdma">
          <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-138" data-mp="3sppddstuhpl8" />
        </button>
      </div>
    </div>;
}